<template>
  <v-list elevation="2">
    <v-list-item
      v-for="(nav, i) in menu"
      :key="i"
      :to="{ name: nav.to }"
      exact
    >
      <template v-slot:prepend>
        <v-icon v-if="pageHasError(nav.label)" color="red">
          mdi-alert
        </v-icon>
        <v-icon v-else-if="pageIsFinished(nav.label)" color="green">
          mdi-checkbox-marked-outline
        </v-icon>
        <v-icon v-else-if="nav.label !== 'review'" color="orange">
          mdi-checkbox-blank-outline
        </v-icon>
        <v-icon
          v-else-if="nav.label == 'review'"
          :color="campaign.is_unfinished ? 'grey' : 'green'"
        >
          mdi-check-decagram
        </v-icon>
      </template>
      <v-list-item-title>
        {{ t("campaign." + type + ".nav." + nav.label) }}
      </v-list-item-title>
    </v-list-item>
  </v-list>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useCampaignStore } from '@/stores/campaign'

defineProps({
  menu: {
    type: Array,
    required: true
  },
  type: {
    type: String,
    required: true
  }
})

const { t } = useI18n()
const campaignStore = useCampaignStore()

const pageHasError = computed(() => campaignStore.pageHasError)
const pageIsFinished = computed(() => campaignStore.pageIsFinished)
const campaign = computed(() => campaignStore.campaign)
</script>
